const initialState = () => ({
  agreement: {},
  psm: {},
  payee: {},
  selectedCorpId: null,
  partnerBranches: [],
  allPaymentMethods: {},
  selectedPaymentMethods: {},
  chargebeeCustomers: {},
  allBranchInfo: {},
  allTaxExemptions: {},
  setupIntent: {},
  cardToken: '',
  source: '',
  paymentMethodId: '',
  paymentMethod: '',
  partnerSettings: {},

  // New Agreement State
  newAgreement: {
    corpId: null,
    adminId: null,
    depositCorpId: null,
    contractPeriod: null,
    deploymentPeriod: null,
    notifyBillingEmail: null,
    agreementDate: null,
    branded: false,
    manualPayment: false,
    totalKitCommitment: null,
    platformFee: false,
    platformFeeAmount: null,
    connectFee: false,
    connectProduct: null,
    connectFreeUsers: null,
    gen2Preorder: false,
    agreementOrders: [{
      corpId: null,
      shippingAddressId: null,
      shippingCost: null,
      taxEstimation: null,
      orderTotal: null,
      customerPo: null,
      plannedStartDate: null,
      agreementOrderLines: [{
        productId: null,
        itemName: null,
        price: null,
        sku: null,
        subscriptionPlanId: null,
        quantity: null,
        total: 0,
      }],
    }],
  },
  agreementPdf: null,

  showActionModal: false,
  actionModalView: null,
});

export default initialState;
